import { EmptyServicesImage } from '../..';

export interface PALFilterBodyProps {
  portfoliosNotSelected: JSX.Element[];
  accountsNotSelected: JSX.Element[];
  locationsNotSelected: JSX.Element[];
}

const sectionLineClass = 'border-gray-300';

export const PALFilterBody = (props: PALFilterBodyProps) => {
  const { portfoliosNotSelected = [], accountsNotSelected = [], locationsNotSelected = [] } = props;
  const totalLength = portfoliosNotSelected.length + accountsNotSelected.length + locationsNotSelected.length;

  return totalLength === 0 ? (
    <div className="py-6 text-center">
      <EmptyServicesImage className="mx-auto" />
      <p className="headline-xxs my-2">No customers found</p>
      <p className="my-4">Please try changing your search term.</p>
    </div>
  ) : (
    <>
      {portfoliosNotSelected}
      {portfoliosNotSelected.length > 0 ? <hr className={sectionLineClass} /> : undefined}
      {accountsNotSelected}
      {portfoliosNotSelected.length > 0 || accountsNotSelected.length > 0 ? (
        <hr className={sectionLineClass} />
      ) : undefined}
      {locationsNotSelected}
    </>
  );
};

export default PALFilterBody;
